import {useInfiniteQuery} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {CommentDto, PaginatedResponse} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

type Params = {
  riaId: string
  pageSize: number
}

export const useRiaComments = ({riaId, pageSize}: Params) => {
  return useInfiniteQuery<PaginatedResponse<CommentDto>, AxiosError>({
    queryKey: [...riskSurveyQueryKeys.rias.comments(riaId), pageSize] as const,
    queryFn: ({pageParam, signal}) =>
      riskSurveyQueries.getRiaComments(riaId, pageParam as number, pageSize, signal),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    enabled: !!riaId,
    staleTime: 60_000,
    gcTime: 300_000
  })
}
